module.exports = __webpack_public_path__ + "static/media/tomatoe.8d17498e.jpg";